import React from 'react';
import '../../scss/workoffice.scss';
import { Box } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import person4 from '../../assets/IconsSidebar/person-4.png';
import moment from 'moment';
import { WorkOfficeFunctionality } from './Functionality/WorkOffice';
import ImagePreview from '../../components/ImagePreview';
import ButtonAction from './../../components/buttons/ButtonAction';
import HeadTittle from './../../components/HeadTittle';
import Subtitle from '../../components/Header/Subtitle';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const WorkOffice = () => {
    //Function to get the functionality of home office
    const { checkInFn, checkOutFn, getWorkOffice, getUserFullInformation, t } = WorkOfficeFunctionality();

    return (
        <div className='work_office_container'>
            <div className='work_office_items'>
                <div className='card '>
                    <Box className='mt-3 mb-3'>
                        <HeadTittle name='home_office' />
                    </Box>
                    <Box className='mb-3'>
                        <ImagePreview
                            preview={
                                getUserFullInformation.selfie
                                    ? `data:image/png;base64,${getUserFullInformation?.selfie}`
                                    : person4
                            }
                            className='avatar avatar-fit-container '
                        />
                    </Box>
                    <Subtitle
                        className='mt-3'
                        name='!Welcome'
                        view={getWorkOffice.checkIn === null || getWorkOffice.checkOut === null}
                        setView={false}
                    ></Subtitle>
                    {getWorkOffice.checkIn != null && getWorkOffice.checkOut != null && (
                        <div className='ibl-h3'>{t('today_shift_has_ended').toUpperCase()}</div>
                    )}

                    {(getWorkOffice.checkIn || getWorkOffice.checkOut) && (
                        <div className='check_in ibl-paragraph-black mt-3'>
                            {t('check_in_at').toUpperCase()} - {moment(getWorkOffice.checkIn).format('HH:mm:ss')}
                        </div>
                    )}

                    {getWorkOffice.checkOut && (
                        <div className='check_in  ibl-paragraph-black'>
                            {t('check_out_at').toUpperCase()} - {moment(getWorkOffice.checkOut).format('HH:mm:ss')}
                        </div>
                    )}

                    <Box>
                        {getWorkOffice?.checkIn === null && getWorkOffice?.checkOut === null && (
                            <ButtonAction
                                id='btn_wo_check_in'
                                className='btn-icon-add'
                                onClick={() => checkInFn()}
                                name={t('check-in')}
                                Icon={ExitToAppIcon}
                            />
                        )}

                        {getWorkOffice.checkIn != null && getWorkOffice.checkOut === null && (
                            <ButtonAction
                                id='btn_wo_check_out'
                                className='btn-icon-add'
                                onClick={() => checkOutFn()}
                                name={t('check-out')}
                                Icon={ExitToAppIcon}
                            />
                        )}
                    </Box>
                </div>
            </div>
        </div>
    );
};

export default WorkOffice;
